<template>
  <v-container id="certification-container">
    <v-snackbar v-model="snackbar" bottom left :timeout="4000">{{
      snackbarText
    }}</v-snackbar>

    <Title title="Certifications"></Title>

    <v-row>
      <v-col sm="3">
        <span style="cursor: pointer" @click="onFilterCertifications('total')">
          <InsightCard :title="'Certification'" :count="totalCertification" />
        </span>
      </v-col>
      <v-col sm="3" v-if="$store.state.role != 'centre'">
        <span
          style="cursor: pointer"
          @click="onFilterCertifications('aoPending')"
        >
          <InsightCard :title="'Moderation Pending'" :count="totalAoPending" />
        </span>
      </v-col>
      <v-col sm="3" v-if="$store.state.role == 'centre'">
        <span
          style="cursor: pointer"
          @click="onFilterCertifications('centrePending')"
        >
          <InsightCard :title="'Pending'" :count="totalCentrePending" />
        </span>
      </v-col>
      <v-col sm="3" v-if="$store.state.role == 'centre'">
        <span
          style="cursor: pointer"
          @click="onFilterCertifications('uploadRequired')"
        >
          <InsightCard
            :title="'Upload Required'"
            :count="totalUploadRequired"
          />
        </span>
      </v-col>
      <v-col sm="3" v-if="$store.state.role != 'centre'">
        <span
          style="cursor: pointer"
          @click="onFilterCertifications('moderationRequired')"
        >
          <InsightCard
            :title="'Moderation Required'"
            :count="totalModerationRequired"
          />
        </span>
      </v-col>
      <v-col sm="3">
        <span
          style="cursor: pointer"
          @click="onFilterCertifications('notPrinted')"
        >
          <InsightCard
            :title="'Approved (Not Printed)'"
            :count="totalApprovedNotPrinted"
          />
        </span>
      </v-col>
      <v-col sm="3">
        <span
          style="cursor: pointer"
          @click="onFilterCertifications('printed')"
        >
          <InsightCard
            :title="'Approved (Printed)'"
            :count="totalApprovedPrinted"
          />
        </span>
      </v-col>
    </v-row>

    <v-row class="mt-5">
      <!-- <BulkUploader :type="'certification'" style="float: right" /> -->

      <v-col md="12">
        <CertificationsTable
          @amendAwardedDate="amendAwardedDate"
          @setDateRangeData="setDateRangeData"
          :headers="modifiedCertificationsHeaders"
          :items="modifiedCertifications"
          :title="'Certifications'"
          :isLoading="isCertificationsLoading"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import InsightCard from "../components/InsightCard";
import CertificationsTable from "../components/CertificationsTable";
import Title from "../components/Title";
// import BulkUploader from "../components/BulkUploader";

export default {
  mounted: function() {
    this.getCertifications();
  },
  components: {
    InsightCard,
    CertificationsTable,
    Title
    // BulkUploader,
  },
  data() {
    return {
      snackbar: false,
      snackbarText: "",
      isCertificationsLoading: true,
      certifications: [],
      modifiedCertifications: [],
      certificationsHeaders: [
        { text: "Student Name", value: "learnerName" },
        { text: "Qualification Code", value: "qualification" },
        { text: "Centre Name", value: "centreName" },
        { text: "Status", value: "status" },
        { text: "Certificate No.", value: "certificateNumber" },
        { text: "Awarded Date", value: "certificationIssueDate" },
        { text: "Request Date", value: "createdAt" },
        // { text: "Approved Date", value: "approvedDate" },
        { text: "Actions", value: "actions", align: "end", sortable: false }
      ]
    };
  },
  watch: {
    isCertificationsLoading: function(newValue) {
      this.isCertificationsLoading = newValue;
    }
  },
  computed: {
    modifiedCertificationsHeaders: function() {
      if (this.$store.state.role == "centre") {
        return [
          { text: "Student Name", value: "learnerName" },
          { text: "Qualification Code", value: "qualification" },
          { text: "Centre Name", value: "centreName" },
          { text: "Status", value: "status" },
          { text: "Certificate No.", value: "certificateNumber" },
          { text: "Awarded Date", value: "certificationIssueDate" }
        ];
      } else {
        return this.certificationsHeaders;
      }
    },
    totalCertification: function() {
      if (this.certifications) {
        return this.certifications.length;
      }

      return 0;
    },
    totalAoPending: function() {
      const totalAoPending = this.certifications.filter(certification => {
        if (certification.status) {
          return (
            certification.status.toLowerCase() == "pending" ||
            certification.status.toLowerCase() == "moderation"
          );
        }
      });

      return totalAoPending.length;
    },
    totalCentrePending: function() {
      const totalCentrePending = this.certifications.filter(certification => {
        if (certification.status) {
          return (
            certification.status.toLowerCase() == "pending" ||
            certification.status.toLowerCase() == "submitted"
          );
        }
      });

      return totalCentrePending.length;
    },
    totalApprovedNotPrinted: function() {
      const totalApprovedNotPrinted = this.certifications.filter(
        certification => {
          if (certification.status) {
            return (
              certification.status.toLowerCase() == "approved" &&
              (!certification.isPrinted || certification.isPrinted === false)
            );
          }
        }
      );

      return totalApprovedNotPrinted.length;
    },
    totalApprovedPrinted: function() {
      const totalApprovedPrinted = this.certifications.filter(certification => {
        if (certification.status) {
          return (
            certification.status.toLowerCase() == "approved" &&
            certification.isPrinted === true
          );
        }
      });

      return totalApprovedPrinted.length;
    },
    totalUploadRequired: function() {
      const totalUploadRequired = this.certifications.filter(certification => {
        if (certification.status) {
          return certification.status.toLowerCase() == "moderation";
        }
      });

      return totalUploadRequired.length;
    },
    totalModerationRequired: function() {
      const totalModerationRequired = this.certifications.filter(
        certification => {
          if (certification.status) {
            return certification.status.toLowerCase() == "submitted";
          }
        }
      );

      return totalModerationRequired.length;
    }
  },
  methods: {
    setDateRangeData: function(d) {
      var fromdate = d.fromdate;
      var todate = d.todate;

      console.log(d);
      this.modifiedCertifications = this.certifications.filter(
        certification => {
          if (!fromdate || !todate) return true;
          if (certification.status) {
            return (
              new Date(certification.certificationIssueDate) >=
                new Date(fromdate) &&
              new Date(certification.certificationIssueDate) <= new Date(todate)
            );
          }
        }
      );
    },
    amendAwardedDate: function(message) {
      this.getCertifications();
      this.snackbarText = message;
      this.snackbar = true;
    },
    getCertifications: function() {
      this.isCertificationsLoading = true;

      fetch(`${process.env.VUE_APP_ROOT_API}/certifications?status=approved`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`
        }
      })
        .then(response => response.json())
        .then(data => {
          this.isCertificationsLoading = false;
          this.certifications = data.certifications;
          this.modifiedCertifications = data.certifications;
        })
        .catch(error => {
          console.error(error);
        });
    },
    onFilterCertifications: function(type) {
      if (type == "total") {
        this.modifiedCertifications = this.certifications;
      } else if (type == "aoPending") {
        this.modifiedCertifications = this.certifications.filter(
          certification => {
            if (certification.status) {
              return (
                certification.status.toLowerCase() == "pending" ||
                certification.status.toLowerCase() == "moderation"
              );
            }
          }
        );
      } else if (type == "centrePending") {
        this.modifiedCertifications = this.certifications.filter(
          certification => {
            if (certification.status) {
              return (
                certification.status.toLowerCase() == "pending" ||
                certification.status.toLowerCase() == "submitted"
              );
            }
          }
        );
      } else if (type == "uploadRequired") {
        this.modifiedCertifications = this.certifications.filter(
          certification => {
            if (certification.status) {
              return certification.status.toLowerCase() == "moderation";
            }
          }
        );
      } else if (type == "moderationRequired") {
        this.modifiedCertifications = this.certifications.filter(
          certification => {
            if (certification.status) {
              return certification.status.toLowerCase() == "submitted";
            }
          }
        );
      } else if (type == "notPrinted") {
        this.modifiedCertifications = this.certifications.filter(
          certification => {
            if (certification.status) {
              return (
                certification.status.toLowerCase() == "approved" &&
                (!certification.isPrinted || certification.isPrinted === false)
              );
            }
          }
        );
      } else if (type == "printed") {
        this.modifiedCertifications = this.certifications.filter(
          certification => {
            if (certification.status) {
              return (
                certification.status.toLowerCase() == "approved" &&
                certification.isPrinted === true
              );
            }
          }
        );
      }
    }
  }
};
</script>

<style scoped>
#certification-container {
  min-height: 100vh;
}
</style>
